import { connect } from 'react-redux';

import Content from './content';

const mapState = ({ url }) => ({
    url
});

export default connect(mapState)(Content);
